var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrmLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IRM"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.75,
    d: "M17.9431 10.6521L26.841 25.3261L35.8126 40.0001H17.9431H0L8.97153 25.3261L17.9431 10.6521Z",
    fill: "#13487D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.75,
    d: "M31.5473 0.00012207L40.5188 20.0372L49.4904 39.9998H31.5473H13.6042L22.5758 20.0372L31.5473 0.00012207Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.75,
    d: "M24.7084 5.73521L33.6799 22.8673L42.6514 39.9994H24.7084H6.83887L15.8104 22.8673L24.7084 5.73521Z",
    fill: "#6DCFF6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmLogo);
export default __webpack_public_path__ + "static/media/IRM_Logo.df382c6cea3a0c14eef0d3ebcfe1746d.svg";
export { ForwardRef as ReactComponent };